import(/* webpackMode: "eager" */ "/vercel/path0/src/app/artists/[slug]/error.tsx");
